import script from "./MemberDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberDetailCard.vue?vue&type=script&setup=true&lang=ts"

import "./MemberDetailCard.vue?vue&type=style&index=0&id=0201297a&scoped=true&lang=css"
import "./MemberDetailCard.vue?vue&type=style&index=1&id=0201297a&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0201297a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
